import React, { useEffect, useState } from "react";
import "../Landing.scss";
import "../ln.scss";
import QomitaLogo from "../../../assets/img/qomita-logo.jpg";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import url from "../../../url.json";
import Modal from "react-modal";
import { tokenReducer } from "../../../Redux/Reducers/Token/TokenReducer";
import { langReducer } from "../../../Redux/Reducers/Lang/langReducer";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 20,
    border: "1px solid #E1E8EB",
    padding: 0,
    width: "min(420px, calc(100vw - 32px))",
    boxShadow: "0 24px 48px rgba(15,27,42,0.18)",
  },
  overlay: { zIndex: 1000, background: "rgba(15,27,42,0.45)" },
};

export const PHONES = [
  { value: "+998774206076", label: "(77) 420-60-76" },
  { value: "+998774206046", label: "(77) 420-60-46" },
];
export const EMAIL = "gnkc@vetgov.uz";

const LANGS = [
  { code: "uz", label: "UZ" },
  { code: "ru", label: "RU" },
  { code: "en", label: "EN" },
];

function LandingHead({ t }) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const selectlan = useSelector((state) => state.langReducer);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem("user") || "null");
  const loggedIn = localStorage.getItem("token") && user?.legal_entity != null;

  useEffect(() => {
    if (["uz", "ru", "en"].includes(selectlan.value)) {
      i18n.changeLanguage(selectlan.value);
    }
  }, [selectlan.value]);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.hash]);

  const changeLang = (lng) => {
    localStorage.setItem("lan", lng);
    dispatch(langReducer(lng));
    i18n.changeLanguage(lng);
  };

  const handleClickLog = () => {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("token")}`;
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    axios.post(url.url + "/logout").finally(() => {
      setIsOpen(false);
      dispatch(tokenReducer(null));
      window.location.href = "/";
    });
  };

  // Bosh sahifadagi bo'limga o'tish (boshqa sahifadan ham ishlaydi)
  const goSection = (e, id) => {
    e.preventDefault();
    setMenuOpen(false);
    if (location.pathname === "/") {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      window.history.replaceState(null, "", `#${id}`);
    } else {
      navigate(`/#${id}`);
    }
  };

  const nav = (
    <nav className="ln-nav" aria-label={t("ln_menu")}>
      <a href="/#services" onClick={(e) => goSection(e, "services")}>
        {t("ln_nav_services")}
      </a>
      <NavLink to="/reestr-new">{t("Reestr")}</NavLink>
      <NavLink to="/regulations">{t("Regulations")}</NavLink>
      <a href="/#news" onClick={(e) => goSection(e, "news")}>
        {t("News")}
      </a>
      <NavLink to="/faq">{t("FAQ")}</NavLink>
      <a href="/#contact" onClick={(e) => goSection(e, "contact")}>
        {t("Contact")}
      </a>
    </nav>
  );

  const lang = (
    <div className="ln-lang" role="group">
      {LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          className={selectlan.value == l.code ? "is-active" : ""}
          onClick={() => changeLang(l.code)}
        >
          {l.label}
        </button>
      ))}
    </div>
  );

  const auth = loggedIn ? (
    <div className="ln-auth">
      <Link to="/account/applications" className="ln-btn ln-btn_primary">
        {t("ln_cabinet")}
      </Link>
      <button
        type="button"
        className="ln-icon-btn"
        title={t("Logout")}
        aria-label={t("Logout")}
        onClick={() => setIsOpen(true)}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" /></svg>
      </button>
    </div>
  ) : (
    <div className="ln-auth">
      <Link to="/login" className="ln-btn ln-btn_outline">
        {t("Sign in")}
      </Link>
      <Link to="/register/frist-step" className="ln-btn ln-btn_primary">
        {t("Sign up")}
      </Link>
    </div>
  );

  return (
    <>
      <div className="ln-util">
        <div className="ln-wrap">
          <span className="ln-util__org">{t("ln_center")}</span>
          <div className="ln-util__right">
            {PHONES.map((p) => (
              <a key={p.value} href={`tel:${p.value}`}>{p.label}</a>
            ))}
            <a href={`mailto:${EMAIL}`} className="ln-util__mail">{EMAIL}</a>
            <span>{t("ln_hours_short")}</span>
          </div>
        </div>
      </div>

      <header className="ln-header">
        <div className="ln-wrap">
          <Link
            to="/"
            className="ln-brand"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <img
              className="ln-brand__logo"
              src={QomitaLogo}
              alt="Oziq-ovqat mahsulotlari xavfsizligi qo'mitasi"
              width={44}
              height={44}
            />
            <span className="ln-brand__text">
              <span className="ln-brand__name">
                Vis Nefrit
              </span>
              <span className="ln-brand__sub">{t("ln_subbrand")}</span>
            </span>
          </Link>

          {nav}

          <div className="ln-actions">
            {lang}
            {auth}
            <button
              type="button"
              className="ln-icon-btn ln-burger"
              aria-label={t("ln_menu")}
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((v) => !v)}
            >
              {menuOpen ? (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>
              ) : (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
              )}
            </button>
          </div>
        </div>

        {menuOpen ? (
          <div className="ln-mobile">
            <div className="ln-wrap">
              {nav}
              {lang}
              {auth}
            </div>
          </div>
        ) : (
          ""
        )}
      </header>

      <Modal
        isOpen={modalIsOpen}
        ariaHideApp={false}
        onRequestClose={() => setIsOpen(false)}
        style={customStyles}
        contentLabel="Logout"
      >
        <div className="ln-modal">
          <span className="ln-modal__icon" aria-hidden="true">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" /></svg>
          </span>
          <h3 className="ln-modal__title">{t("Do you want to log out?")}</h3>
          <p className="ln-modal__text">{t("ln_logout_text")}</p>
          <div className="ln-modal__actions">
            <button
              className="ln-btn ln-btn_outline"
              type="button"
              onClick={() => setIsOpen(false)}
            >
              {t("Cancel")}
            </button>
            <button
              className="ln-btn ln-btn_danger"
              type="button"
              onClick={handleClickLog}
            >
              {t("Logout")}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default withTranslation()(LandingHead);
